<template>
  <div class="text-center">
    <v-alert
      dense
      color="primary"
      text
      max-width="350px"
      class="mx-auto"
      elevation="0"
    >
      <div
        v-if="!clock.date"
        class="text-center"
      >
        <v-progress-circular
          :width="20"
          :height="20"
          color="primary"
          indeterminate
        ></v-progress-circular>
      </div>
      <div v-else class="d-flex align-center justify-center">
        <div class="mr-5 d-flex align-center">
          <div class="mt-1">
            <Icon
              :width="20"
              :height="20"
              class="mr-2"
              :icon="'calendar'"
            />
          </div>
          <div>
            {{ clock.date | moment('DD/MM/YYYY') }}
          </div>
        </div>
        <div class="d-flex align-center">
          <div class="mt-1">
            <Icon
              :width="20"
              :height="20"
              class="mr-2"
              :icon="'clock-outline'"
            />
          </div>
          <div>
            {{ clock.date | moment('hh:mm:ss a') }}
          </div>
        </div>
      </div>
    </v-alert>
  </div>
</template>

<script>
/* eslint-disable */
import { Component, Vue } from 'vue-property-decorator'

@Component({
  components: {
    Icon: () => import(/* webpackPrefetch: true */ '@/components/Icon.vue')
  },
  props: {
    initDate: {
      type: Date,
      default: null
    },
    startDate: {
      type: Date,
      default: null
    },
    waitingDate: {
      type: Date,
      default: null
    },
    endDate: {
      type: Date,
      default: null
    },
    scheduledEventState: {
      type: Object,
      default: null
    },
    code: {
      type: Number,
      default: null
    }
  },
  watch: {
    'clock.date': function () {
      this.timeChecker()
    }
  }
})
export default class Clock extends Vue {
  data () {
    return {
      clock: {
        date: new Date(),
        interval: null
      }
    }
  }

  beforeDestroy () {
    clearInterval(this.clock.interval)
  }

  mounted () {
    this.initClock()
  }

  initClock () {
    this.clock.interval = setInterval(() => {
      this.clock.date = new Date()
    }, 1000)
  }

  timeChecker () {
    if (!this.scheduledEventState || (this.scheduledEventState.id === 2 || this.scheduledEventState.id === 3 || this.scheduledEventState.id === 4  || this.scheduledEventState.id === 6)) {
      return false
    }

    const date = this.clock.date

    if ((date.getTime() >= this.endDate.getTime()) && this.code !== 1) {
      this.$emit('verifyLink')
    } else if ((date.getTime() >= this.initDate.getTime()) && (date.getTime() < this.startDate.getTime()) && this.code !== 3) {
      this.$emit('verifyLink')
    } else if ((date.getTime() >= this.startDate.getTime()) && (date.getTime() < this.waitingDate.getTime()) && this.code !== 4) {
      this.$emit('verifyLink')
    } else if ((date.getTime() >= this.waitingDate.getTime()) && (date.getTime() < this.endDate.getTime()) && this.code !== 5) {
      this.$emit('verifyLink')
    }
  }
}
</script>
